module.exports = __webpack_public_path__ + "img/milva-logo-white.96fb8c6f.svg";